<template>
  <v-app>
    <v-container>
      <v-content>
        <div class="message text-xs-center pt-5">
          <h1>Page not found</h1>
          <v-card>
            <v-card-text>
              <v-btn to="/">Home</v-btn>
            </v-card-text>
          </v-card>
        </div>
      </v-content>
    </v-container>
  </v-app>
</template>

<script>
  export default {};
</script>

<style lang="less" scoped>
  @import '../../style/variables.less';

  .application {
    background-color: @edval-dark;
  }

  .message {
    color: #ffffff;

    .v-card {
      border-radius: 0;
      display: inline-block;
      padding: 0 50px;
      margin: 30px 0;
    }
  }
</style>
